<template>
  <div class="p-6">
    <div class="benefit-card box rounded-xl shadow-lg my-2 p-4" v-for="(data,key) in welfare" :key="key">
      <div class="flex flex-col">
        <h5 class="text-theme-1 text-base font-medium">{{data.name}}</h5>
        <div class="text-theme-37 flex items-center flex-wrap" v-for="(list,key_2) in data.list" :key="key_2">
          &emsp;-&emsp;{{list.desc}} 
          <div v-if="(list.code == 'WFCY5') && (information.cy_education ? Object.keys(information.cy_education).length > 0 : false)">
            <div class="p-1 m-1 border border-theme-39 text-theme-37 rounded-md" >{{information.cy_education.desc}} {{information.cy_education.name}}</div>
          </div>
          <div class="flex flex-wrap" v-if="(list.code == 'WFCY2') && ( information.cy_subsidy?.length > 0)">
            <div class="p-1 m-1 border border-theme-39 text-theme-37 rounded-md" v-for="(sub, key_3) in information.cy_subsidy.filter(x => x.code != 'POOR')" :key="key_3">{{`${sub.type} จำนวน ${new Intl.NumberFormat().format(sub.amount)} บาท`}}</div>
          </div>
          <div class="p-1 m-1 border border-theme-39 text-theme-37 rounded-md"  v-if="list.name">{{list.name}}</div>
        </div>
        <!-- <p class="text-theme-37">&emsp;-&emsp;การศึกษาตามช่วงวัย</p> -->
      </div>
    </div>
    <!-- <div class="benefit-card box rounded-xl shadow-lg my-2 p-4">
      <div class="flex flex-col">
        <h5 class="text-theme-1 text-base font-medium">ด้านผู้สูงอายุ</h5>
        <p class="text-theme-37">&emsp;-&emsp;ให้คำแนะนำ/ ปรึกษา</p>
      </div>
    </div> -->
  </div>
</template>

<script setup>
import { computed } from "vue";
const props = defineProps({
  information: Object,
});
const welfare = computed(() => {
  const welfareObj = {welf_children_youth : "ด้านเด็กและเยาวชน", welf_disability :"ด้านคนพิการ", welf_women:"ด้านสตรี" ,welf_eldery:"ด้านผู้สูงอายุ", welf_helpless_persons:"ด้านคนไร้ที่พึ่ง", welf_others:"ด้านอื่นๆ"}
  let result = []
  Object.keys(welfareObj).forEach(element => {
    if((props.information[element] ?? false) &&  (props.information[element]?.length > 0)){
      result.push({
        name: welfareObj[element],
        list: props.information[element]
      })
    }
  });

  return result
});
</script>

<style lang="scss" scoped>
.benefit-card {
  position: relative;
  padding-left: 2rem;
  &::before {
    content: "";
    background-color: #15286c;
    width: 10px;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    border-top-left-radius: 0.75rem;
    border-bottom-left-radius: 0.75rem;
  }
}
</style>
